import { createContext, type PropsWithChildren, use, useState } from 'react'
import { type SharedValue, useSharedValue } from 'react-native-reanimated'

export type ScrollContextType = {
  scrollY: SharedValue<number>
  maxScrollY: number
  setMaxScrollY: (maxScrollY: number) => void
}

export const ScrollContext = createContext<ScrollContextType | null>(null)

export const ScrollContextProvider = ({ children }: PropsWithChildren) => {
  const scrollY = useSharedValue(0)
  const [currentMaxScrollY, setCurrentMaxScrollY] = useState(0)

  return (
    <ScrollContext.Provider
      value={{
        scrollY,
        maxScrollY: currentMaxScrollY,
        setMaxScrollY: setCurrentMaxScrollY,
      }}>
      {children}
    </ScrollContext.Provider>
  )
}

export function useScrollContext() {
  const context = use(ScrollContext)

  if (!context) {
    throw new Error(
      // eslint-disable-next-line i18next/no-literal-string
      'useScrollContext must be used within a ScrollContextProvider'
    )
  }

  return context
}
